var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideNavStarlink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.768399 14.3858L0.0873181 15.0613H7.2474C16.4715 3 24 0 24 0C7.12516 6 4.1738 11.044 0.768399 14.3858Z",
    fill: "#53545C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3239 15.0613H23.279L13.8 8.4C12.6 9.6 12.6 9.6 11.4 10.8L17.3239 15.0613ZM6.44411 2.36961H0.489014L7.20005 7.2C8.21294 6.50676 9.1173 6.03992 10.2 5.4L6.44411 2.36961Z",
    fill: "#53545C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNavStarlink);
export default __webpack_public_path__ + "static/media/SideNavStarlink.efb7c3279bea1415619dfbe9ca39bffa.svg";
export { ForwardRef as ReactComponent };